var ytEventListeners = [];
var ytPlayers = [];

//------------------------------
/*var tag = document.createElement('script');
tag.src = "//www.youtube.com/iframe_api";
tag.async = true;
tag.defer = true;
var firstScriptTag = document.getElementsByTagName('script')[0];
setTimeout(function(){ firstScriptTag.parentNode.insertBefore(tag, firstScriptTag); }, 2000);*/

var playerObjs = [];
var topInside = false;
var bottomInside = false;
var topInsideBefore = false;
var bottomInsideBefore = false;
var ytPlayersPop = [];

jQuery(document).ready(function($){
    (function() {

        function loadScript() {
            if (typeof(YT) == 'undefined' || typeof(YT.Player) == 'undefined') {
                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                tag.async = true;
                tag.defer = true;
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
        }

        function ready(fn) {
            if (document.readyState !== 'loading'){
              fn();
            } else {
              document.addEventListener('DOMContentLoaded', fn);
            }
        }    

        ready(function () {
            loadScript();                     
        });

        var youtube = document.querySelectorAll(".youtube");
        for (var i = 0; i < youtube.length; i++) {
            var source = "https://img.youtube.com/vi/" + youtube[i].dataset.embed + "/maxresdefault.jpg";            
            if (!$(youtube[i]).find("img").length) {
                var image = new Image();
                image.src = source;
                image.className += " img-responsive";
                image.addEventListener("load", function () {
                    youtube[i].appendChild(image);
                }(i));
            }
            ytEventListeners[i] = function () {
                var iframe = document.createElement("div");
                this.innerHTML = "";
                this.appendChild(iframe);          
                var parentblock = this.parentElement;               
                if (parentblock.classList.contains('wrap-video-youtube')) {                  
                    parentblock.classList.add("active-player");
                }                
                var ytPlayer = {id: this.dataset.embed, mcPlayer: new YT.Player(iframe, {
                    height: 500,
                    width: 500,
                    videoId: this.dataset.embed,
                    host: 'https://www.youtube-nocookie.com',
                    playerVars: { 
                        autoplay: 1, 
                        rel: 0, 
                        showinfo: 0,
                        cc_load_policy: 1,
                        cc_lang_pref: document.documentElement.lang.split('-').shift(),
                    },
                    events: {
                        onReady: function(event){
                            event.target.playVideo();
                        },
                        onStateChange: function(event) {
                            if (event.data == YT.PlayerState.PLAYING){
                                for(var x in ytPlayers){
                                    if(ytPlayers.hasOwnProperty(x) && ytPlayers[x].id != ytPlayer.id && typeof ytPlayers[x].mcPlayer !== 'undefined'){
                                        try{
                                            ytPlayers[x].mcPlayer.pauseVideo();
                                        }
                                        catch(err){}
                                    }
                                }
                            }
                        }
                  }
                })};
                ytPlayers.push(ytPlayer);
            };
            youtube[i].addEventListener("click", ytEventListeners[i]);
        }
    })();  

    if ($('.popup-modal-card').length > 0) {
        $('.popup-modal-card').each(function() {
            var youtube = $(this).get(0).querySelectorAll(".modal-body .youtube.story__image");
            if (youtube.length > 0) {
                for (var i = 0; i < youtube.length; i++) {
                    var vid = youtube[i].dataset.embed;
                    $(this).on('hide.bs.modal', function (e) {
                        for(var x in ytPlayers){
                            if(ytPlayers.hasOwnProperty(x) && ytPlayers[x].id == vid && typeof ytPlayers[x].mcPlayer !== 'undefined'){
                                try{
                                    ytPlayers[x].mcPlayer.pauseVideo();
                                }
                                catch(err){}
                            }
                        };
                    });
                }
            }
        });
    }

    //---------------------------------
    //this function must be global
    window.onYouTubeIframeAPIReady = function() {

        $('.js-hero-header-play').each(function(){
            var playerObj = {};
            playerObjs.push(playerObj);
            playerObj.id = Math.random();
            playerObj.componentPlay = $(this);
            playerObj.paused = false;
            playerObj.pausedManualy = false;
            playerObj.componentPlay.on('click touchend', function() {
                playerObj.playerContainer = $(this).parents('.hero-header-main').find('.js-hero-header-player');
                playerObj.playerContainerParent = $(this).parents('.hero-header-main');
                playerObj.playerContainerImage = $(this).parents('.hero-header-main').find('.js-hero-header-image');
                playerObj.playerContainerImageMobile = $(this).parents('.hero-header-main').find('.js-hero-header-image-mobile');
                playerObj.playerContainerImageMobile.css('max-height','55vw');
                handleSinglePlayer(playerObj);
                var w = parseInt(playerObj.playerContainerParent.width());
                var cw = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                if(cw<=992){
                    var h = parseInt(playerObj.playerContainerImageMobile.css('height'));
                }
                else{
                    var h = parseInt(playerObj.playerContainerParent.css('height'));
                }
                var videoUrl = playerObj.componentPlay.data('video-url');
                var pezzi = videoUrl.split('/');
                var videoId = pezzi[pezzi.length-1];
                playerObj.playerContainer.css('height', h);
                var parentblock = playerObj.playerContainer.parents('.hero-header-main');
                parentblock.addClass('hero-header-player-active');
                parentblock[0].scrollIntoView();
                playerObj.mcPlayer = new YT.Player(playerObj.playerContainer[0], {
                    height:h,
                    width:w,
                    videoId:videoId,
                    host: 'https://www.youtube-nocookie.com',
                    playerVars: { 
                        controls:1, 
                        rel:0,
                        autohide:2,
                        showinfo:0,
                        showsearch:0, 
                        mute:0, 
                        modestbranding:0,
                        cc_load_policy:1,
                        iv_load_policy:3,
                        theme:'light',
                        cc_lang_pref: document.documentElement.lang.split('-').shift()
                    },
                    events: {
                        onReady: function(event){
                            event.target.playVideo();
                            playerObj.playerContainerImage.visibility({
                                once: false,
                                initialCheck: true,
                                observeChanges: false,
                                refreshOnLoad: true,
                                onBottomVisible: function() {
                                    playerObj.bottomInside = true;
                                    playerObj.bottomInsideBefore = playerObj.bottomInside;
                                    playerObj.topInsideBefore = playerObj.topInside;
                                },
                                onBottomVisibleReverse: function() {
                                    playerObj.bottomInside = false;
                                    playerObj.bottomInsideBefore = playerObj.bottomInside;
                                    playerObj.topInsideBefore = playerObj.topInside;
                                },
                                onTopVisible: function() {
                                    playerObj.topInside = true;
                                    playerObj.bottomInsideBefore = playerObj.bottomInside;
                                    playerObj.topInsideBefore = playerObj.topInside;
                                },
                                onTopVisibleReverse: function() {
                                    playerObj.topInside = false;
                                    playerObj.bottomInsideBefore = playerObj.bottomInside;
                                    playerObj.topInsideBefore = playerObj.topInside;
                                }
                            });
                        },
                        onStateChange: function(event) {
                            if (event.data == YT.PlayerState.PLAYING){
                                playerObj.paused = false;         
                                handleSinglePlayer(playerObj);
                                if(playerObj.pausedManualy){
                                    playerObj.pausedManualy = false;
                                    event.target.seekTo(playerObj.pausedAt);
                                }
                            }
                            else if (event.data == YT.PlayerState.PAUSED){
                                playerObj.paused = true;
                                setTimeout(function(){
                                    if (playerObj.paused){
                                        playerObj.pausedManualy = true;
                                        playerObj.pausedAt = event.target.getCurrentTime();
                                    }                                   
                                }, 500);
                            }
                            else if (event.data == YT.PlayerState.ENDED){
                                event.target.stopVideo();
                                playerObj.playerContainerParent.removeClass('hero-header-player-active');
                                playerObj.playerContainerImage.prepend('<div class="js-hero-header-player"></div>');
                                playerObj.playerContainerImageMobile.css('max-height','none');
                                playerObj.playerContainerParent.find('iframe').remove();
                            }
                        }
                    }
                });
            });
        });

        //video in popup    
        if ($('.resource-modal-video').length > 0) {
            $('.resource-modal-video').each(function() {   
                var videoid, youtube, iframe;
                $(this).on('hide.bs.modal', function (e) { 
                    for (var x in ytPlayersPop){
                        if (ytPlayersPop.hasOwnProperty(x) && ytPlayersPop[x].id == videoid && typeof ytPlayersPop[x].mcPlayer !== 'undefined'){
                            try {
                                ytPlayersPop[x].mcPlayer.pauseVideo();                     
                            }
                            catch(err){}
                        }
                    };
                });
                $(this).on('show.bs.modal', function (e) {
                    var curvideoid = $('#video-modal-resource-video').attr('data-videoid');              
                    if (curvideoid !== videoid) {
                        $(this).find('iframe').remove();
                        videoid = curvideoid;
                        youtube = document.getElementById('youtube-video-' + $(this).data('vid'));
                        iframe = document.createElement("div");
                        youtube.innerHTML = "";
                        youtube.appendChild(iframe);  
                        var ytPlayer = {id: videoid, mcPlayer: new window.YT.Player(iframe, {
                            videoId:videoid,
                            playlist:videoid,
                            host: 'https://www.youtube-nocookie.com',
                            playerVars: {
                                rel:0,
                                loop:1,
                                autohide:2,
                                showinfo:0,
                                showsearch:0, 
                                mute:0, 
                                modestbranding:0,
                                cc_load_policy:1,
                                iv_load_policy:3,
                                theme:'light',
                                cc_lang_pref:document.documentElement.lang.split('-').shift(),
                            },
                            events: {
                                'onReady': onPlayerReady,
                            }
                        })};                            
                        ytPlayer.paused = false;
                        ytPlayer.pausedManualy = false;
                        ytPlayersPop.push(ytPlayer);   
                    } else {
                        for(var x in ytPlayersPop){
                            if (ytPlayersPop.hasOwnProperty(x) && ytPlayersPop[x].id == videoid && typeof ytPlayersPop[x].mcPlayer !== 'undefined'){
                                try {
                                    ytPlayersPop[x].mcPlayer.playVideo();                              
                                }
                                catch(err){}
                            }
                        }
                    }
                });
    
                function onPlayerReady(event) {
                    event.target.playVideo();
                };
    
            });  
            
        } else if ($('.popup-modal-video').length > 0) {

            $('.popup-modal-video').each(function() {
                var videoid = $(this).data('videoid');
                var youtube = document.getElementById('youtube-video-' + $(this).data('vid'));
                var iframe = document.createElement("div");
                iframe.setAttribute('allowfullscreen', 'allowfullscreen');
                youtube.innerHTML = "";
                youtube.appendChild(iframe);
                var ytPlayer = {id: videoid, mcPlayer: new window.YT.Player(iframe, {
                    videoId:videoid,
                    playlist:videoid,
                    host: 'https://www.youtube-nocookie.com',
                    playerVars: {
                        rel:0,
                        loop:1,
                        autohide:2,
                        showinfo:0,
                        showsearch:0, 
                        mute:0, 
                        modestbranding:0,
                        cc_load_policy:1,
                        iv_load_policy:3,
                        theme:'light',
                        cc_lang_pref:document.documentElement.lang.split('-').shift(),
                    }
                })};                  
                ytPlayer.paused = false;
                ytPlayer.pausedManualy = false;
                ytPlayersPop.push(ytPlayer);            
                $(this).on('hide.bs.modal', function (e) {
                    for (var x in ytPlayersPop){
                        if (ytPlayersPop.hasOwnProperty(x) && ytPlayersPop[x].id == videoid && typeof ytPlayersPop[x].mcPlayer !== 'undefined'){
                            try {
                                ytPlayersPop[x].mcPlayer.pauseVideo();                     
                            }
                            catch(err){}
                        }
                    };
                });

                $(this).on('shown.bs.modal', function (e) {
                    for(var x in ytPlayersPop){
                        if (ytPlayersPop.hasOwnProperty(x) && ytPlayersPop[x].id == videoid && typeof ytPlayersPop[x].mcPlayer !== 'undefined'){
                            try {
                                ytPlayersPop[x].mcPlayer.playVideo();                                                           
                               // var requestFullScreen = iframe.requestFullScreen || iframe.mozRequestFullScreen || iframe.webkitRequestFullScreen;
                               // if (requestFullScreen) {
                               //     requestFullScreen.bind(iframe)();
                               // }
                            }
                            catch(err){}
                        }
                    }
                });
            });       
        }

        // Simple Video Block  
        var simpleyoutube = document.querySelectorAll(".simple-video-preview-block");
        Array.from(simpleyoutube).forEach(target => {  
            
            var iframe = document.createElement("div");
            iframe.setAttribute('class', 'youtube-iframe');
            if (target.classList.contains('portrait-video-preview-block')) {
                iframe.dataset.gaVideo = "looped";
            }
            target.appendChild(iframe);
            if (target.classList.contains('video-preview-block')) {
                target.classList.add("active-player");
            }
            var videoUrl = target.dataset.videoUrl.split('/');
            var vid = videoUrl[videoUrl.length-1];
            var ytPlayer = {id: vid, paused: false, mcPlayer: new window.YT.Player(iframe, {
                videoId: vid,
                host: 'https://www.youtube-nocookie.com',
                playerVars: { 
                    autoplay: 1,
                    controls: 0,
                    disablekb: 0, 
                    fs: 0,
                    modestbranding: 1,
                    iv_load_policy: 3,
                    rel: 0, 
                    showinfo: 0,
                    cc_load_policy: 1,
                    cc_lang_pref: document.documentElement.lang.split('-').shift(),                                  
                },
                events: {
                    onReady: function(event){
                        ytPlayer.paused = false;
                        event.target.mute();
                        event.target.playVideo();        
                    },
                    onStateChange: function(event) {
                        if (event.data == YT.PlayerState.PLAYING){
                            ytPlayer.paused = false;
                        } else if (event.data == YT.PlayerState.PAUSED){    
                            ytPlayer.paused = true;
                            setTimeout(function(){     
                                if (ytPlayer.paused){  
                                    target.classList.add("paused-player");
                                }     
                            }, 500);                                   
                        } else if (event.data == YT.PlayerState.ENDED){
                            event.target.seekTo(0);
                            event.target.playVideo();
                        }
                    }
                }
            })};   
            ytPlayers.push(ytPlayer);
        }); 
    }

    $(window).resize(function(){
        window.resizeFrame();
    }); 

    function handleSinglePlayer(playerObj){
        for(var x in playerObjs){
            if(playerObjs.hasOwnProperty(x) && playerObjs[x].id != playerObj.id && typeof playerObjs[x].mcPlayer !== 'undefined'){

                try{
                    playerObjs[x].mcPlayer.pauseVideo();
                }
                catch(err){}
            }
        }
    }
});    

window.popupVideo = function(videoid) {
    jQuery('#video-modal-resource-video').attr('data-videoid',videoid).modal('show');
}

window.resizeFrame = function() {
    var cw = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;    
    jQuery('.paragraph-md-video .js-hero-header-player').each(function(){
        var w = jQuery(this).parents('.hero-header-main');
        if (cw<=992) {           
            var h = parseInt(jQuery(this).parents('.hero-header-main').find('.js-hero-header-image-mobile').css('height'));
        } else {
            var h = parseInt(jQuery(this).parents('.hero-header-main').css('height'));
        }
        jQuery(this).css('height', h); 
    });
}